import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  height: 100%;
  width: 100%;
  flex-direction: row;
  display: flex;
  gap: 3.75rem;

  @media (max-width: 1023px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

export const FormColumn = styled.div`
  min-width: 0;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  width: 100%;
  display: flex;
`;

export const StyledFormColumnTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
  margin-bottom: 0.5rem;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  color: ${COLORS.DARK_ONYX} !important;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;
